import { createContext } from "react";

// Auth context holds user, userInfo, login and logout functions
// Default value is null - only available inside AuthProvider
const AuthContext = createContext(null);

export default AuthContext;